import React, { Component } from 'react';
import styles from './BurgerDropDownMenu.scss';


export default class BurgerDropDownMenu extends Component {
  render() {
    return (
      <div className={styles.burgerBtn}>
        <div />
        <div />
        <div />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/BurgerDropDownMenu/BurgerDropDownMenu.jsx
 **/